import {APIInterface} from '../APIInterface'

class LocalDatabaseController extends APIInterface {
    constructor() {
        super();
    }

    fileUploadDropzoneUrl() {
        return null;
    }

    getFanTypeList() {
        return "Local Database Controller getFanTypeList";
    }

    getFanSortList() {
        return "Local Database Controller getFanSortList";
    }

    getAppPathsList() {
        return "Local Database Controller getAppPathsList";
    }

    getMaterialSortList() {
        return "Local Database Controller getMaterialSortList";
    }

    getAppPathsFanTypesList() {
        return "Local Database Controller getAppPathsFanTypesList";
    }

    getAppPathsParametersSettingsList() {
        return "Local Database Controller getAppPathsParametersSettingsList";
    }

    getAppTableParametersSettingsList() {
        return "Local Database Controller getAppTableParametersSettingsList";
    }

    getAppPathsWorkPointsSettingsList() {
        return "Local Database Controller getAppPathsWorkPointsSettingsList";
    }

    getAppFansImagesList() {
        return "Local Database Controller getAppFansImagesList";
    }

    getLanguagesList() {
        return "Local Database Controller getLanguagesList";
    }

    getTranslationsList() {
        return "Local Database Controller getTranslationsList";
    }

    getUnitsList() {
        return "Local Database Controller getUnitsList";
    }

    getUnitTypesList() {
        return "Local Database Controller getUnitTypesList";
    }

    getMeasurementsList() {
        return "Local Database Controller getMeasurementsList";
    }

    getFanCharacteristicsList() {
        return "Local Database Controller getFanCharacteristicsList";
    }

    getFansTypesList() {
        return "Local Database Controller getFansTypesList";
    }

    getConnectionsList() {
        return "Local Database Controller getConnectionsList";
    }

    getEngineStartupList() {
        return "Local Database Controller getEngineStartupList";
    }

    getOctaveNoiseList() {
        return "Local Database Controller getOctaveNoiseList";
    }

    getFansExtrasList() {
        return "Local Database Controller getFansTypesList";
    }

    sendMaterialRequest() {
        return "Local Database Controller getFansTypesList";
    }

    getRelationsFanVersionsExtrasList() {
        return "Local Database Controller getRelationsFanVersionsExtrasList";
    }

    getFansOfPath(id_app_fan_type, id_app_fan_sort) {
        return "Local Database Controller getFansOfPath";
    }

    manageReturnedData(returnedData, defaultData) {
        return null;
    }

    loginUser() {
        throw new Error('You shall not login locally');
    }

    registerUser() {
        throw new Error('You shall not pass locally');
    }

    verifyUser() {
        throw new Error('You shall not verify locally');
    }

    getDefaultManufacturer() {
        throw new Error('getDefaultManufacturer not implemented');
    }

    getEnginesList() {
        throw new Error('getEnginesList not implemented');
    }

    getPricesList(userToken) {
        throw new Error('getPricesList not implemented');
    }

    getCurrenciesList() {
        throw new Error('getCurrenciesRates not implemented');
    }

    getFansAtexesList() {
        throw new Error('getFansAtexesList not implemented');
    }

    getRelationsFanAtexes() {
        throw new Error('getRelationsFanAtexes not implemented');
    }

    getFansVersionsList() {
        throw new Error('getFansVersionsList not implemented');
    }

    getRelationsFanTypesPositionsList() {
        throw new Error('getRelationsFanTypesPositionsList not implemented');
    }

    getFansPositionsList() {
        throw new Error('getFansPositionsList not implemented');
    }

    getSettingsFullList() {
        throw new Error('getSettingsFullList not implemented');
    }

    getVariablesFullList() {
        throw new Error('getVariablesFullList not implemented');
    }

    sendOffer() {
        throw new Error('sendOffer not implemented');
    }

    approveOffer() {
        throw new Error('approveOffer not implemented');
    }

    cancelOffer() {
        throw new Error('cancelOffer not implemented');
    }

    getOffersOfUser() {
        throw new Error('getOffersOfUser not implemented');
    }

    getOfferOfId() {
        throw new Error('getOfferOfId not implemented');
    }

    getOfferOfServerId() {
        throw new Error('getOfferOfServerId not implemented');
    }

    getFanByTypeNumber(data){
        throw new Error('getFanByTypeNumber not implemented');
    }

    getFanByTypeNumberHandshake(data){
        throw new Error('getFanByTypeNumberHandshake not implemented');
    }

    checkUserToken(data) {
        throw new Error('checkUserToken not implemented');
    }

    getSinglePdf(data) {
        throw new Error('getSinglePdf not implemented');
    }

    postResetPassword(data) {
        throw new Error('postResetPassword not implemented');
    }

    postRequestPasswordReset(data) {
        throw new Error('postRequestPasswordReset not implemented');
    }

    getLastEvent() {
        throw new Error('getLastEvent not implemented');
    }

    getOfferSurchargesOptions() {
        throw new Error('getOfferSurchargesOptions not implemented');
    }

    getOfferDiscountsOptions() {
        throw new Error('getOfferDiscountsOptions not implemented');
    }

    getOfferAntiCorrosionOptions() {
        throw new Error('getOfferAntiCorrosionOptions not implemented');
    }

    logChoiceTime() {
        throw new Error('logChoiceTime not implemented');
    }

    getFansAtexTypes() {
        throw new Error('getFansAtexTypes not implemented');
    }

    getTemperatureRangesWithManufacturers() {
        throw new Error('getTemperatureRangesWithManufacturers not implemented');
    }

    getEfficiencyRangesWithIeClass() {
        throw new Error('getEfficiencyRangesWithIeClass not implemented');
    }

    getFanRender() {
        throw new Error('getFanRender not implemented');
    }

    removeFileFromServer() {
        throw new Error('removeFileFromServer not implemented');
    }
}

export {LocalDatabaseController};
